import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react-lite';
import cn from 'classnames';
import isEmpty from 'lodash/isEmpty';
import { useStores } from 'hooks/useStores';
import Button from 'ati-ui-react/components/Button';
import { addMetric } from 'utils/addMetrics';
import postContactsViewed from 'services/postContactsViewed';

import {
  OwnerInfoContainer,
  Header,
  Contacts,
  FirmInfoWrapper,
  ButtonContainer,
} from './OwnerInfoStyles';
import FirmInfo from './components/FirmInfo';
import Contact from './components/Contact';

const OwnerInfo = observer(() => {
  const {
    advertsStore: { currentAccount, currentAdvert, stars },
    statusesStore: { getStatuses, statuses },
  } = useStores();

  const isPurchase = currentAdvert.advert_type === 'purchase';
  const [isShowedContacts, setShowedContacts] = useState(false);

  const currentStars = stars[currentAccount?.account_id];

  useEffect(() => {
    if (currentAccount?.account_id) {
      getStatuses({
        [currentAccount.account_id]: currentAccount,
      });
    }
  }, [currentAccount]);

  const contactsFilter = (contact) => {
    if (currentAdvert.contacts !== undefined) {
      return currentAdvert.contacts.includes(contact.id);
    }
    return true;
  };

  const contactsForAdvert = currentAccount?.contacts?.filter((contact) => contactsFilter(contact));

  // Нужно будет вернуть
  // return authStatus && currentAccount ? (
  //   <OwnerInfoContainer>
  //     <Header>Продавец</Header>
  //     <FirmInfo mt={14} account={currentAccount} advert={currentAdvert} stars={currentStars} />
  //     <Contacts>
  //       {isShowedContacts ? (
  //         currentAccount?.contacts
  //           ?.filter(contactsFilter)
  //           .map((item, i) => (
  //             <Contact
  //               key={item.id}
  //               status={statuses[`${currentAccount?.account_id}.${item.id}`]}
  //               idFirm={currentAccount?.account_id}
  //               contact={item}
  //               contactId={item.id}
  //               fullContactId={`${currentAccount?.account_id}.${item.id}`}
  //               mt={i === 0 ? 0 : 8}
  //             />
  //           ))
  //       ) : (
  //         <Button target="_blank" className="button" onClick={() => setShowedContacts(true)}>
  //           Показать контакты
  //         </Button>
  //       )}
  //     </Contacts>
  //   </OwnerInfoContainer>
  // ) : (
  //   <Lock />
  // );
  const getHeader = () => {
    if (currentAdvert.advert_type === 'sale') return 'Продавец';
    if (currentAdvert.advert_type === 'rent') return 'Арендодатель';
    if (currentAdvert.advert_type === 'purchase' && currentAdvert.proposal_type === 'purchase')
      return 'Покупатель';
    if (currentAdvert.advert_type === 'purchase' && currentAdvert.proposal_type === 'rent')
      return 'Арендатор';
    throw new Error('Error getting header in owner block on truck page');
  };

  const handleShowContacts = () => {
    addMetric('tm-click-contacts');
    setShowedContacts(true);
    postContactsViewed(currentAdvert._id);
  };

  // Временно показываем контакты всем пользователям по кнопке
  return (
    currentAccount &&
    currentAdvert && (
      <OwnerInfoContainer className={cn({ purchase: isPurchase })}>
        <Header>{getHeader()}</Header>
        <FirmInfoWrapper>
          <FirmInfo
            mt={14}
            account={currentAccount}
            advert={currentAdvert}
            stars={currentStars}
            contactsConfirmedCount={currentAccount?.confirmed_contacts_quantity}
          />
          {!isShowedContacts && !isEmpty(currentAccount.contacts) && (
            <ButtonContainer>
              <Button target="_blank" className="button" onClick={handleShowContacts}>
                Показать контакты
              </Button>
            </ButtonContainer>
          )}
        </FirmInfoWrapper>
        <Contacts>
          {isShowedContacts &&
            contactsForAdvert.map((item, i) => (
              <Contact
                key={item.id}
                status={statuses[`${currentAccount?.account_id}.${item.id}`]}
                idFirm={currentAccount?.account_id}
                contact={item}
                contactId={item.id}
                fullContactId={`${currentAccount?.account_id}.${item.id}`}
                mt={i === 0 ? 0 : 8}
                isConfirmed={item.confirmed}
              />
            ))}
        </Contacts>
      </OwnerInfoContainer>
    )
  );
});

export default OwnerInfo;
